import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/home';
import Error from './pages/error';

const Paths = () => {
    return ( <>
    <BrowserRouter >
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Error />} />
    </Routes>
    </BrowserRouter>
    </> );
}
 
export default Paths;